var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import s from './DataTable.scss';
import classNames from 'classnames';
import InfiniteScroll from './InfiniteScroll';
import WixComponent from '../BaseComponents/WixComponent';
import ArrowVertical from '../Icons/dist/components/ArrowVertical';

var DataTable = function (_WixComponent) {
  _inherits(DataTable, _WixComponent);

  function DataTable(props) {
    _classCallCheck(this, DataTable);

    var _this = _possibleConstructorReturn(this, (DataTable.__proto__ || Object.getPrototypeOf(DataTable)).call(this, props));

    _this.wrapWithInfiniteScroll = function (table) {
      return React.createElement(
        InfiniteScroll,
        {
          pageStart: 0,
          loadMore: _this.loadMore,
          hasMore: _this.state.currentPage < _this.state.lastPage || _this.props.hasMore,
          loader: _this.props.loader,
          useWindow: _this.props.useWindow,
          scrollElement: _this.props.scrollElement
        },
        table
      );
    };

    _this.renderTable = function (rowsToRender) {
      var style = { width: _this.props.width };
      return React.createElement(
        'div',
        null,
        React.createElement(
          'table',
          { id: _this.props.id, style: style, className: s.table },
          React.createElement(
            'thead',
            null,
            React.createElement(
              'tr',
              null,
              _this.props.columns.map(_this.renderHeaderCell)
            )
          ),
          _this.renderBody(rowsToRender)
        )
      );
    };

    _this.renderBody = function (rows) {
      return React.createElement(
        'tbody',
        null,
        rows.map(_this.renderRow)
      );
    };

    _this.renderRow = function (rowData, rowNum) {
      var _this$props = _this.props,
          onRowClick = _this$props.onRowClick,
          onMouseEnterRow = _this$props.onMouseEnterRow,
          onMouseLeaveRow = _this$props.onMouseLeaveRow,
          rowDataHook = _this$props.rowDataHook,
          dynamicRowClass = _this$props.dynamicRowClass,
          rowDetails = _this$props.rowDetails;

      var rowClasses = [_this.props.rowClass];
      var optionalRowProps = {};

      var handlers = [{ rowEventHandler: onRowClick, eventHandler: 'onClick' }, { rowEventHandler: onMouseEnterRow, eventHandler: 'onMouseEnter' }, { rowEventHandler: onMouseLeaveRow, eventHandler: 'onMouseLeave' }];

      handlers.forEach(function (_ref) {
        var rowEventHandler = _ref.rowEventHandler,
            eventHandler = _ref.eventHandler;

        if (rowEventHandler) {
          optionalRowProps[eventHandler] = function (event) {
            if (event.isDefaultPrevented()) {
              return;
            }
            rowEventHandler(rowData, rowNum);
            _this.tryToggleRowDetails(eventHandler, rowNum);
          };
        }
      });

      if (onRowClick) {
        rowClasses.push(s.clickableDataRow);
      }

      if (rowDataHook) {
        optionalRowProps['data-hook'] = rowDataHook;
      }

      if (dynamicRowClass) {
        rowClasses.push(dynamicRowClass(rowData, rowNum));
      }

      optionalRowProps.className = classNames(rowClasses);

      var rowsToRender = [React.createElement(
        'tr',
        _extends({ key: rowNum }, optionalRowProps),
        _this.props.columns.map(function (column, colNum) {
          return _this.renderCell(rowData, column, rowNum, colNum);
        })
      )];

      if (rowDetails) {
        var showDetails = !!_this.state.selectedRows[rowNum];
        rowsToRender.push(React.createElement(
          'tr',
          { key: rowNum + '_details' },
          React.createElement(
            'td',
            { 'data-hook': rowNum + '_details', className: classNames(s.details, showDetails ? s.active : ''), colSpan: _this.props.columns.length },
            showDetails && rowDetails(rowData, rowNum)
          )
        ));
      }

      return rowsToRender;
    };

    _this.renderCell = function (rowData, column, rowNum, colNum) {
      var classes = classNames(_defineProperty({}, s.important, column.important));
      return React.createElement(
        'td',
        { className: classes, key: colNum },
        column.render && column.render(rowData, rowNum)
      );
    };

    _this.renderSortingArrow = function (sortDescending, colNum) {
      if (sortDescending === undefined) {
        return null;
      }
      var sortDirectionClassName = sortDescending ? s.sortArrowAsc : s.sortArrowDesc;
      return React.createElement(
        'span',
        { 'data-hook': colNum + '_title', className: sortDirectionClassName },
        React.createElement(ArrowVertical, null)
      );
    };

    _this.renderHeaderCell = function (column, colNum) {
      var style = {
        width: column.width,
        padding: _this.props.thPadding,
        height: _this.props.thHeight,
        fontSize: _this.props.thFontSize,
        cursor: column.sortable === undefined ? 'arrow' : 'pointer'
      };

      var optionalHeaderCellProps = {};
      if (column.sortable) {
        optionalHeaderCellProps.onClick = function () {
          return _this.props.onSortClick && _this.props.onSortClick(column, colNum);
        };
      }
      return React.createElement(
        'th',
        _extends({ style: style, key: colNum }, optionalHeaderCellProps),
        column.title,
        _this.renderSortingArrow(column.sortDescending, colNum)
      );
    };

    _this.calcLastPage = function (_ref2) {
      var data = _ref2.data,
          itemsPerPage = _ref2.itemsPerPage;
      return Math.ceil(data.length / itemsPerPage) - 1;
    };

    _this.loadMore = function () {
      if (_this.state.currentPage < _this.state.lastPage) {
        _this.setState({ currentPage: _this.state.currentPage + 1 });
      } else {
        _this.props.loadMore && _this.props.loadMore();
      }
    };

    _this.tryToggleRowDetails = function (eventHandler, selectedRow) {
      if (eventHandler !== 'onClick') {
        return;
      }
      var selectedRows = _defineProperty({}, selectedRow, !_this.state.selectedRows[selectedRow]);
      if (_this.props.allowMultiDetailsExpansion) {
        selectedRows = Object.assign({}, _this.state.selectedRows, _defineProperty({}, selectedRow, !_this.state.selectedRows[selectedRow]));
      }
      _this.setState({ selectedRows: selectedRows });
    };

    var state = { selectedRows: {} };
    if (props.infiniteScroll) {
      state = _extends({}, state, _this.createInitialScrollingState(props));
    }
    _this.state = state;
    return _this;
  }

  _createClass(DataTable, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var isLoadingMore = false;
      if (this.props.infiniteScroll && nextProps.data !== this.props.data) {
        if (nextProps.data instanceof Array && this.props.data instanceof Array) {
          if (this.props.data.every(function (elem, index) {
            return nextProps.data.length > index && nextProps.data[index] === elem;
          })) {
            isLoadingMore = true;
            this.setState({ lastPage: this.calcLastPage(nextProps) });
          }
        }

        if (!isLoadingMore) {
          this.setState(this.createInitialScrollingState(nextProps));
        }
      }
    }
  }, {
    key: 'createInitialScrollingState',
    value: function createInitialScrollingState(props) {
      return { currentPage: 0, lastPage: this.calcLastPage(props) };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          showHeaderWhenEmpty = _props.showHeaderWhenEmpty,
          infiniteScroll = _props.infiniteScroll,
          itemsPerPage = _props.itemsPerPage;


      if (!data.length && !showHeaderWhenEmpty) {
        return null;
      }

      var rowsToRender = infiniteScroll ? data.slice(0, (this.state.currentPage + 1) * itemsPerPage) : data;

      var table = this.renderTable(rowsToRender);

      if (infiniteScroll) {
        return this.wrapWithInfiniteScroll(table);
      }

      return table;
    }
  }]);

  return DataTable;
}(WixComponent);

function validateData(props, propName) {
  if (props[propName]) {
    if (props[propName].constructor && props[propName].constructor.name && props[propName].constructor.name.toLowerCase().indexOf('array') > -1) {
      return null;
    } else {
      return Error('Data element must be an array type');
    }
  }
  return null;
}

DataTable.defaultProps = {
  data: [],
  columns: [],
  showHeaderWhenEmpty: false,
  infiniteScroll: false,
  itemsPerPage: 20,
  width: '100%',
  loadMore: null,
  hasMore: false,
  loader: React.createElement(
    'div',
    { className: 'loader' },
    'Loading ...'
  ),
  scrollElement: null,
  useWindow: true,
  thPadding: '5px',
  thHeight: '36px',
  thFontSize: '12px'
};

DataTable.propTypes = {
  id: PropTypes.string,
  data: validateData,
  columns: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
    render: PropTypes.func.isRequired,
    sortable: PropTypes.bool,
    sortDescending: PropTypes.bool
  })),
  showHeaderWhenEmpty: PropTypes.bool,
  rowDataHook: PropTypes.string,
  rowClass: PropTypes.string,
  dynamicRowClass: PropTypes.func,
  onRowClick: PropTypes.func,
  onMouseEnterRow: PropTypes.func,
  onMouseLeaveRow: PropTypes.func,
  infiniteScroll: PropTypes.bool,
  itemsPerPage: PropTypes.number,
  width: PropTypes.string,
  loadMore: PropTypes.func,
  hasMore: PropTypes.bool,
  loader: PropTypes.node,
  useWindow: PropTypes.bool,
  scrollElement: PropTypes.object,
  thPadding: PropTypes.string,
  thHeight: PropTypes.string,
  thFontSize: PropTypes.string,
  rowDetails: PropTypes.func,
  allowMultiDetailsExpansion: PropTypes.bool,
  onSortClick: PropTypes.func
};

DataTable.displayName = 'DataTable';

export default DataTable;
//# sourceMappingURL=DataTable.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/DataTable/DataTable.js